import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Media } from '@/js/libs/ui/src/theme/Media';
import { Icons, Select } from '@/js/libs/ui/src/V2';
import { getDataTestId } from '@/js/libs/utils/get-data-test-id';
import { isDefinedDateRange } from '../../helpers';
import { Header, MobileHeader, Preset, PresetsWrapper } from './styled';
export const RangePresets = React.memo(function RangePresets({ title = 'Period', presets, startDate, endDate, onChange, }) {
    const isMobile = useMediaQuery({ query: Media.xsMax });
    const selectOptions = React.useMemo(() => presets.map(({ title, dateRange }) => ({
        label: title,
        value: dateRange,
    })), [presets]);
    const selectedValue = React.useMemo(() => {
        const activePreset = presets.find(({ isActive, dateRange }) => isActive([startDate, endDate], dateRange));
        return activePreset ? { label: activePreset.title, value: activePreset.dateRange } : undefined;
    }, [endDate, presets, startDate]);
    const handleSelectChange = useCallbackRef((option) => {
        if (option?.value && isDefinedDateRange(option.value)) {
            onChange(option.value);
        }
    });
    const createRangePresetClickHandler = useCallbackRef((dateRange) => () => {
        if (isDefinedDateRange(dateRange)) {
            onChange(dateRange);
        }
    });
    return (_jsx("div", { children: isMobile ? (_jsxs("div", { children: [_jsx(MobileHeader, { children: title }), _jsx(Select, { options: selectOptions, value: selectedValue, onChange: handleSelectChange })] })) : (_jsxs(_Fragment, { children: [_jsx(Header, { children: title }), _jsx(PresetsWrapper, { children: presets.map(({ isActive, title, dateRange, dataTestId }) => {
                        const isActivePreset = isActive([startDate, endDate], dateRange);
                        return (_jsxs(Preset, { "data-testid": getDataTestId(dataTestId), onClick: createRangePresetClickHandler(dateRange), isActive: isActivePreset, isCustom: !dateRange[1] && !dateRange[1], range: true, children: [title, isActivePreset && _jsx(Icons.Checkmark, { size: 20 })] }, title));
                    }) })] })) }));
});
